import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setSelectedInsurancePlan } from '../../redux/InsurancePlans';

import { useMediaQuery, useTheme, Grid, Box } from '@material-ui/core';
import WizardLayout from '../../components/WizardLayout';
import WizardNavigation from '../../components/WizardNavigation';
import CardsCarousel from '../../components/CardsCarousel';
import useWizardSteps from '../../hooks/useWizardSteps';

import Modal from '../../components/Modal';
import ModelForm from '../../components/ModelForm';
import './style.scss';
import LifeDeclaration from '../../components/LifeDeclaration';
import CompanyInfo from '../../components/CompanyInfo';

const nextSteps = {
  HOGAR: '/domicilio',
  'PERTENENCIAS PROTEGIDAS': '/beneficiarios',
  'MOVILIDAD': '/beneficiarios',
  'ACCIDENTES PERSONALES': '/beneficiarios',
  'ROBO EN CAJERO AUTOMATICO': '/beneficiarios',
  MASCOTA: '/mascota/detalles',
  AUTOMOTOR: '/automotor/datosauto',
};

export default function AllPlans() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const history = useHistory();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  const [open, setOpen] = useState(false);

  const { insurancePlans, insuranceSelected } = useSelector(
    ({ insurancePlans, insurances }) => ({
      insurancePlans: insurancePlans.plans,
      insuranceSelected: insurances.selected,
    })
  );

  const { insuranceName } = insuranceSelected || {};

  const mainInsuranceCoverages =
    insurancePlans && insurancePlans[0].insuranceCoverages.slice(0, 4);

  const suggestion = (
    <span>
      <b>Elegí el plan</b> que mejor se adapte a vos
    </span>
  );

  const handleClick = (plan, goTo) => {
    dispatch(setSelectedInsurancePlan(plan));
    if (
      insuranceSelected.insuranceName !== 'TECNO' &&
      insuranceSelected.insuranceName !== 'VIDA INDIVIDUAL' &&
      insuranceSelected.insuranceName !== 'INTEGRAL DE COMERCIO'
    ) {
      if (!goTo) goTo = nextSteps[insuranceName];
      return history.push(goTo);
    } else {
      setOpen(true);
    }
  };

  const handlePlanInfo = (plan, goTo) => {
    dispatch(setSelectedInsurancePlan(plan));
    if (!goTo) goTo = nextSteps[insuranceName];
    return history.push(goTo);
  };

  const closeModal = (isOpen) => {
    setOpen(isOpen);
  };

  const renderModal = () => {
    if (insuranceSelected.insuranceName === 'TECNO') {
      return <ModelForm closeModal={closeModal} />;
    } else if (insuranceSelected.insuranceName === 'INTEGRAL DE COMERCIO') {
      return <CompanyInfo closeModal={closeModal} />;
    } else {
      return <LifeDeclaration closeModal={closeModal} />;
    }
  };

  const [activeStep] = useWizardSteps(
    insuranceName === 'INTEGRAL DE COMERCIO' || insuranceName === 'AUTOMOTOR'
      ? 2
      : 1
  );

  return (
    <>
      {open && <Modal closeModal={closeModal}>{renderModal()}</Modal>}
      <WizardLayout
        activeStep={activeStep}
        suggestion={suggestion}
        withBadge
        withTerms
        showNextButton={false}
      >
        {mainInsuranceCoverages && (
          <Grid item xs={12} container justify='center'>
            {insuranceName !== 'AUTOMOTOR' ? (
              <Grid item md={3} container>
                <div className='coverageTitleContainer'>
                  <div className='mainCoverage'>Principales coberturas</div>
                  <div className='coverageContainer'>
                    <ul>
                      {mainInsuranceCoverages.map((coverage) => (
                        <li key={coverage.insuranceCoverageId}>
                          <img
                            className='cardCheck'
                            src={require('../../img/check.svg')}
                            alt=''
                          />
                          {coverage.description}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Grid>
            ) : (
              ''
            )}
            <Grid item xs={12} sm={10} md={9} container>
              <CardsCarousel
                plans={insurancePlans}
                summarized
                smallCard={mdUp}
                maxWidth={600}
                width={mdUp ? 190 : ''}
                handleClick={handleClick}
                handlePlanInfo={handlePlanInfo}
              />
            </Grid>
            <Grid item xs={11} sm={10} md={12}>
              <WizardNavigation next={false} />
              {/* <Box mt={2}>
                *Los importes informados NO incluyen las bonificaciones que
                eventualmente pudieran corresponder a promociones vigentes.
                Dichas bonificaciones serán efectuadas directamente por la
                Compañía Aseguradora y se verán reflejadas en su resumen de
                cuenta o tarjeta de crédito, de acuerdo a la modalidad de pago
                elegida.
              </Box> */}
            </Grid>
          </Grid>
        )}
      </WizardLayout>
    </>
  );
}
